import React, { Component, Fragment } from 'react';
import {
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock
} from 'react-bootstrap';
import axios from 'axios';
import config from '../config';
import SecurityQuestionsForm from './SecurityQuestionsForm';

class Remove2FA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            method: 'backup', // backup | token | questions
            backupCode: '',
            authToken: '',
            error: '',
            success: '',
            isLoading: false,
            preloadedQuestions: []
        };
    }

    componentDidMount() {
    
        axios.get(`${config.baseURL}/auth/securityQuestions`, {})
            .then((response) => {
                const preloadedQuestions = response.data.questions.map((q) => ({
                    questionId: q.question_id,
                    question: q.question,
                    answer: ''
                }));

                this.setState({ preloadedQuestions });
            })
            .catch(() => {
                this.setState({ error: 'Failed to load security questions' });
            });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
            error: '',
            success: ''
        });
    };

    handleMethodChange = (method) => {
        this.setState({ method, error: '', success: '' });
    };

    handleSubmit = () => {
        const { method, backupCode, authToken } = this.state;
        this.setState({ isLoading: true });

        if (method === 'backup') {
            axios
                .post(`${config.baseURL}/auth/disable2fa-with-backup`, { backupCode })
                .then(() => {
                    this.setState({
                        isLoading: false,
                        backupCode: '',
                        success: '2FA has been disabled on your account.'
                    });
                    
                    if (this.props.onSuccess) {
                        this.props.onSuccess();
                    }
                })
                .catch((err) => {
                    this.setState({
                        isLoading: false,
                        error: (err && err.response && err.response.data && err.response.data.message) || 'Failed to disable 2FA. Please try again.'
                    });
                });
        } else if (method === 'token') {
            axios
                .post(`${config.baseURL}/auth/disable2fa-with-token`, { authToken })
                .then(() => {
                    this.setState({
                        isLoading: false,
                        authToken: '',
                        success: '2FA has been disabled on your account.'
                    });
                    if (this.props.onSuccess) {
                        this.props.onSuccess();
                    }
                })
                .catch((err) => {
                    this.setState({
                        isLoading: false,
                        error: (err && err.response && err.response.data && err.response.data.message) || 'Failed to disable 2FA. Please try again.'
                    });
                });
        } else if (method === 'questions') {
            const answers = (this.questionsFormRef && typeof this.questionsFormRef.getAnswers === 'function')
            ? this.questionsFormRef.getAnswers()
            : [];
                        axios
                .post(`${config.baseURL}/auth/disable2fa-with-questions`, { answers })
                .then(() => {
                    this.setState({
                        isLoading: false,
                        success: '2FA has been disabled on your account.'
                    });
                    if (this.props.onSuccess) {
                        this.props.onSuccess();
                    }                })
                .catch((err) => {
                    this.setState({
                        isLoading: false,
                        error: (err && err.response && err.response.data && err.response.data.message) || 'Failed to disable 2FA. Please try again.'
                    });
                });
        }
    };

    render() {
        const { method, backupCode, authToken, error, success, isLoading } = this.state;

        return (
            <Fragment>
            
            <FormGroup>
                <ControlLabel>Select a method to disable 2FA:</ControlLabel>
                <div style={{ marginTop: '0.5rem' }}>
                    <label className="radio-inline">
                        <input
                            type="radio"
                            name="disable2faMethod"
                            value="token"
                            checked={method === 'token'}
                            onChange={() => this.handleMethodChange('token')}
                        />{' '}
                        Use 2FA Code
                    </label>{' '}
                    <label className="radio-inline">
                        <input
                            type="radio"
                            name="disable2faMethod"
                            value="backup"
                            checked={method === 'backup'}
                            onChange={() => this.handleMethodChange('backup')}
                        />{' '}
                        Use Backup Code
                    </label>{' '}
                    <label className="radio-inline">
                        <input
                            type="radio"
                            name="disable2faMethod"
                            value="questions"
                            checked={method === 'questions'}
                            onChange={() => this.handleMethodChange('questions')}
                        />{' '}
                        Use Security Questions
                    </label>
                </div>
            </FormGroup>

                {method === 'backup' && (
                    <FormGroup controlId="backupCode">
                        <ControlLabel>Backup Code</ControlLabel>
                        <FormControl
                            type="text"
                            value={backupCode}
                            onChange={this.handleChange}
                            placeholder="Enter one of your backup codes"
                        />
                    </FormGroup>
                )}

                {method === 'token' && (
                    <FormGroup controlId="authToken">
                        <ControlLabel>2FA Authenticator Code</ControlLabel>
                        <FormControl
                            type="text"
                            value={authToken}
                            onChange={this.handleChange}
                            placeholder="Enter the code from your authenticator app"
                        />
                    </FormGroup>
                )}

                {method === 'questions' && (
                  <SecurityQuestionsForm
                        ref={(ref) => (this.questionsFormRef = ref)}
                        verifyMode={true}
                        preselectedQuestions={this.state.preloadedQuestions}
                 />
                )}

                {error && <HelpBlock className="text-danger">{error}</HelpBlock>}
                {success && <HelpBlock className="text-success">{success}</HelpBlock>}

                <Button
                    bsStyle="danger"
                    disabled={isLoading}
                    onClick={this.handleSubmit}
                >
                    {isLoading ? 'Disabling...' : 'Disable 2FA'}
                </Button>
            </Fragment>
        );
    }
}

export default Remove2FA;
